export type PermissionActionDefinition = {
  name: string;
  description: string;
};

export type PermissionResourceDefinition = {
  name: string;
  code: string;
  type: 'MENU';
  description: string;
  actions: PermissionActionDefinition[];
};

const action = (
  name: string,
  description: string,
): PermissionActionDefinition => ({
  name,
  description,
});

export const PERFORMANCE_CENTER_PERMISSION_RESOURCES = [
  {
    name: '绩效概览',
    code: 'performance-center-overview',
    type: 'MENU',
    description: '控制绩效概览页面访问和下钻',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('open-drilldown', '打开下钻'),
    ],
  },
  {
    name: '我的审批',
    code: 'performance-center-approval',
    type: 'MENU',
    description: '控制绩效中心我的审批页面访问、审批任务查询和业务单据回跳',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('open-source', '回跳业务单据'),
    ],
  },
  {
    name: '我的绩效',
    code: 'performance-center-my',
    type: 'MENU',
    description: '控制我的绩效页面访问和操作',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('submit-goal', '提交目标'),
      action('submit-review', '提交评审'),
      action('confirm-interview', '完成面谈'),
    ],
  },
  {
    name: '团队绩效',
    code: 'performance-center-team',
    type: 'MENU',
    description: '控制团队绩效页面访问和团队下钻',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('open-drilldown', '打开下钻'),
      action('score-review', '主管评分'),
      action('export-team', '导出团队绩效'),
    ],
  },
  {
    name: '绩效档案',
    code: 'performance-center-profiles',
    type: 'MENU',
    description: '控制绩效档案页面访问和详情',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('view-profile', '查看档案'),
      action('export-profiles', '导出档案'),
    ],
  },
  {
    name: '考核周期',
    code: 'performance-center-cycles',
    type: 'MENU',
    description: '控制考核周期页面访问和周期流程',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-cycle', '新增周期'),
      action('edit-cycle', '编辑周期'),
      action('exclude-participant', '移出本期考核'),
      action('view-cycle', '查看周期'),
      action('start-cycle', '启动周期'),
      action('end-cycle', '结束周期'),
      action('archive-cycle', '归档周期'),
      action('delete-cycle', '删除周期'),
      action('initialize-participants', '初始化参与人'),
      action('generate-goals', '生成目标'),
      action('generate-reviews', '生成评审'),
      action('export-cycles', '导出周期'),
      action('export-cycle-participants', '导出参与人'),
    ],
  },
  {
    name: '考核模板',
    code: 'performance-center-cycle-templates',
    type: 'MENU',
    description: '控制考核模板页面访问和模板维护',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-template', '新增模板'),
      action('edit-template', '编辑模板'),
      action('delete-template', '删除模板'),
      action('export-cycle-templates', '导出考核模板'),
    ],
  },
  {
    name: '绩效目标',
    code: 'performance-center-goals',
    type: 'MENU',
    description: '控制绩效目标页面访问和目标处理',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('view-detail', '查看详情'),
      action('create-goal', '新增目标'),
      action('edit-goal', '编辑目标'),
      action('submit-goal', '提交目标'),
      action('confirm-goal', '确认目标'),
      action('delete-goal', '删除目标'),
      action('export-goals', '导出目标'),
    ],
  },
  {
    name: '绩效评估',
    code: 'performance-center-reviews',
    type: 'MENU',
    description: '控制绩效评估页面访问和评估处理',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('view-review', '查看评估'),
      action('submit-review', '提交评估'),
      action('score-review', 'HR 评分'),
      action('calibrate-review', '校准评估'),
      action('publish-review', '发布评估'),
      action('delete-review', '删除评估'),
      action('export-reviews', '导出评估'),
    ],
  },
  {
    name: '评分模板',
    code: 'performance-center-score-templates',
    type: 'MENU',
    description: '控制评分模板页面访问和维护',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-template', '新增模板'),
      action('edit-template', '编辑模板'),
      action('delete-template', '删除模板'),
      action('export-score-templates', '导出评分模板'),
    ],
  },
  {
    name: '绩效校准',
    code: 'performance-center-calibration-batches',
    type: 'MENU',
    description: '控制绩效校准页面访问和校准操作',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-calibration-batch', '新增绩效校准'),
      action('edit-calibration-batch', '编辑绩效校准'),
      action('view-calibration-board', '查看校准看板'),
      action('submit-calibration', '提交校准'),
      action('delete-calibration', '删除绩效校准'),
      action('export-calibration', '导出校准'),
    ],
  },
  {
    name: '绩效面谈',
    code: 'performance-center-interviews',
    type: 'MENU',
    description: '控制绩效面谈页面访问和面谈确认',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('view-interview', '查看面谈'),
      action('edit-interview', '编辑面谈'),
      action('confirm-interview', '完成面谈'),
      action('delete-interview', '删除面谈'),
      action('export-interviews', '导出面谈'),
    ],
  },
  {
    name: '绩效结果',
    code: 'performance-center-results',
    type: 'MENU',
    description: '控制绩效结果页面访问和结果发布',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('view-result', '查看结果'),
      action('publish-result', '发布结果'),
      action('delete-result', '删除结果'),
      action('export-results', '导出结果'),
    ],
  },
  {
    name: '绩效操作记录',
    code: 'performance-center-audits',
    type: 'MENU',
    description: '控制绩效操作记录页面访问和导出',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('view-detail', '查看详情'),
      action('export-audits', '导出审计'),
    ],
  },
  {
    name: '绩效等级',
    code: 'performance-center-grade-rules',
    type: 'MENU',
    description: '控制绩效等级页面访问和规则维护',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('create-rule', '新增规则'),
      action('edit-rule', '编辑规则'),
      action('enable-rule', '启用规则'),
      action('disable-rule', '停用规则'),
      action('export-grade-rules', '导出等级规则'),
    ],
  },
  {
    name: '审批流程设置',
    code: 'performance-center-workflow-settings',
    type: 'MENU',
    description: '控制绩效审批流程设置页面访问和流程启停保存',
    actions: [
      action('view', '查看'),
      action('query', '查询'),
      action('configure-workflow', '设置审批流程'),
      action('save-workflow-settings', '保存审批流程设置'),
    ],
  },
] as const satisfies readonly PermissionResourceDefinition[];

export const PERFORMANCE_PERMISSION_RESOURCE_CODES = {
  overview: 'performance-center-overview',
  approval: 'performance-center-approval',
  my: 'performance-center-my',
  team: 'performance-center-team',
  profiles: 'performance-center-profiles',
  cycles: 'performance-center-cycles',
  cycleTemplates: 'performance-center-cycle-templates',
  goals: 'performance-center-goals',
  reviews: 'performance-center-reviews',
  scoreTemplates: 'performance-center-score-templates',
  calibrationBatches: 'performance-center-calibration-batches',
  interviews: 'performance-center-interviews',
  results: 'performance-center-results',
  audits: 'performance-center-audits',
  gradeRules: 'performance-center-grade-rules',
  workflowSettings: 'performance-center-workflow-settings',
} as const;
